import { render, staticRenderFns } from "./index.vue?vue&type=template&id=104058aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104058aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104058aa')) {
      api.createRecord('104058aa', component.options)
    } else {
      api.reload('104058aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=104058aa&scoped=true", function () {
      api.rerender('104058aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/index.vue"
export default component.exports